export default __webpack_public_path__ + "static/media/landing-computador.a3378bb9.png";